
import { defineComponent } from 'vue'
import { store } from '@/store'
import AppLogo from '@/components/atoms/AppLogo.vue'
export default defineComponent({
  name: 'SignIn',
  components: { AppLogo },
  props: {
    signUp: Boolean,
    next: Function
  },
  setup (props) {
    function signInWithGoogle() {
      store.auth.signInWithGoogle(props.next)
    }
    function signInWithFacebook() {
      store.auth.signInWithFacebook(props.next)
    }
    return { signInWithGoogle, signInWithFacebook }
  }
})
